import React, { useState } from 'react';
import api from '../../api';
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const ForgotPasswordForm = () => {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    api
      .post('/forgot-password', { username })
      .then((response) => {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/reset-password", { state: { username } });
        }, 100);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || 'خطا در ارسال کد');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="content-wrapper login-bg">
      <div className="container-xxl flex-grow-1 container-p-y">
        <ToastContainer position="top-center" autoClose={3000} theme="light" />
        <div className="row justify-content-center mt-5">
          <div className="col-md-6">
            <div className="card rounded-4 border-3 border-dark mb-4">
              <h5 className="card-header bg-dark text-white text-center">فراموشی رمز</h5>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <label className="mb-1" htmlFor="username">شماره ملی</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="username"
                    id="username"
                    maxLength={11}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <button type="submit" className="btn btn-warning w-100" disabled={isLoading}>
                    {isLoading ? 'در حال ارسال...' : 'ارسال پیامک'}
                  </button>
                </form>
                <div className="text-center mt-3">
                  <input
                    type="button"
                    onClick={() => window.location.href = '/login'}
                    className="btn"
                    value='بازگشت به صفحه ورود'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
